import { ObservationPanelContent } from 'pages/pointClouds/components/observationPanel/ObservationPanelContent'
import React, { FC } from 'react'
import styled from 'styled-components'

const ObservationPanelContainer = styled.div<{ $isOpen: boolean }>`
  position: absolute;
  top: 0;
  left: 64px; /* Leave space for the observation button */
  width: 400px;
  background: transparent;
  transform: ${({ $isOpen }) =>
    $isOpen ? 'translateX(0)' : 'translateX(-470px)'};
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  pointer-events: ${({ $isOpen }) => ($isOpen ? 'auto' : 'none')};
  transition:
    transform 200ms ease-out,
    opacity 200ms ease-out;
`

interface HudObservationPanelProps {
  isOpen: boolean
}

export const HudObservationPanel: FC<HudObservationPanelProps> = ({
  isOpen,
}) => {
  return (
    <ObservationPanelContainer $isOpen={isOpen}>
      <ObservationPanelContent />
    </ObservationPanelContainer>
  )
}
